import { createBrowserRouter } from "react-router-dom";

import Mainpage from "../pages/MainPage/Mainpage";
import Login from "../pages/Login";
import Signup from "../pages/Signup";
import SelectType from "../pages/SelectType";
import RecommenderPage from "../pages/RecommenderPage";
export const router =createBrowserRouter([
{
    path:'/',
   
    errorElement:(
        <h3 className="text-center">
            Nothing !
        </h3>
    ),
    children:[
      
        {
            path:'/',
             element:<Mainpage/>,
        },
        {
            path:'/chatBot',
             element:<Login/>,
        },
        {
            path:'/signup',
             element:<Signup/>,
        },
        {
            path:'/selectType',
             element:<SelectType/>,
        },
        {
            path:'/recommender',
             element:<RecommenderPage/>,
        },
    ]
}]);